/** Cells for app/v2 grid layouts (react-grid-layout units: 12 columns, rows of rowHeight px). */

export const GRID_COLS = 12;

const gridPanels = (panels) => (panels || []).filter((p) => p && (p.type === 'component' || p.type === 'chat'));

const num = (v, fallback) => (Number.isFinite(Number(v)) ? Number(v) : fallback);

/**
 * One cell per chat/component panel: saved cells as they are, then a default cell stacked
 * under everything for any panel that has none (e.g. added after the grid was arranged).
 */
export function gridCellsFor(panels, savedCells) {
  const saved = Array.isArray(savedCells) ? savedCells.filter((c) => c && c.i != null) : [];
  const byId = new Map(saved.map((c) => [String(c.i), c]));
  let bottom = saved.reduce((max, c) => Math.max(max, num(c.y, 0) + num(c.h, 0)), 0);
  return gridPanels(panels).map((panel) => {
    const cell = byId.get(String(panel.id));
    if (cell) return cell;
    const next = {
      i: panel.id, x: 0, y: bottom, w: panel.type === 'chat' ? GRID_COLS : GRID_COLS / 2, h: 10, minW: 2, minH: 4,
    };
    bottom += next.h;
    return next;
  });
}

/** Keep only the fields worth saving from a react-grid-layout layout. */
export function cleanGridCells(layout) {
  return (layout || []).map(({
    i, x, y, w, h, minW, minH,
  }) => ({
    i, x, y, w, h, ...(minW ? { minW } : {}), ...(minH ? { minH } : {}),
  }));
}
